<div class="row m-0 ou-input-selector">
  @if(labelValue){
    <label for="filterInput" class="col-form-label ps-0 pb-0">{{labelValue}}</label>
  }

  <input  class="form-control col-sm-10 m-0" autofocus
          id="filterInput"
          placeholder="{{placeholderValue}}"
          [(ngModel)]="value"
          (input)="filterList(value)">
</div>

@if(!value || value === '' || (completeList.indexOf(value) === -1 && list && list.length > 0)){
  <ul class="list-group">
    @for(item of list; track item) {
      <li class="list-group-item" (click)="selectValue(item)">{{item}}</li>
    }
  </ul>
}
